import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function SubjectTabs(props) {
  const [value, setValue] = React.useState('Maths'); // Initialize with the default subject name

  const handleChange = (event, subjectName) => {
    setValue(subjectName); // Set the value to the selected subject name
    props.onFilterChange(subjectName); // Call the callback function with the selected subject name
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {props.standard >= 6 && <Tab label="Maths" value="Maths" {...a11yProps(0)} />}
          {props.standard <= 10 && <Tab label="Science" value="Science" {...a11yProps(1)} />}
          {props.standard > 10 && <Tab label="Physics" value="Physics" {...a11yProps(2)} />}
          {props.standard > 10 && <Tab label="Chemistry" value="Chemistry" {...a11yProps(3)} />}
        </Tabs>
      </Box>
    </Box>
  );
}
